import React, { Fragment } from "react";
import { Tooltip } from "../../../revvComponents";

// Internal Imports
import { GlobalUtils } from "../../../utils";

// Destructuring
const { truncateString } = GlobalUtils;

const DropdownListItem = props => {
  const { type, item, docID, templateId } = props;
  let listItemView = null;
  if (type === "status") {
    listItemView = (
      <li
        key={`${props.item.id}status-dropdown`}
        className="dropdownlistitem-container">
        <div
          onClick={() => props.changeDocumentStatus(docID, item, type)}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0"
          className="dropdownlistitem-status-container">
          <div
            style={{ backgroundColor: item.color }}
            className="status-color-container"
          />
          <Tooltip
            placement="right"
            align={{
              offset: [2, 6],
            }}
            overlayClassName="dropdownlistitem-status-tooltip"
            overlay={`${item.name}`}>
            <div>{item.name ? truncateString(item.name, 12, true) : null}</div>
          </Tooltip>
        </div>
      </li>
    );
  } else if (type === "tags") {
    listItemView = (
      <li
        key={`${props.item.id}tags-dropdown`}
        className="dropdownlistitem-container">
        <div
          onClick={() =>
            props.changeDocumentStatus(docID, item, type, templateId)
          }
          className="dropdownlistitem-button"
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <Tooltip
            placement="right"
            overlayClassName="dropdownlistitem-tooltip"
            align={{
              offset: [2, 6],
            }}
            overlay={`${item.name}`}>
            <div>{item.name ? truncateString(item.name, 22, true) : null}</div>
          </Tooltip>
        </div>
      </li>
    );
  } else if (type === "swimlanes") {
    listItemView = (
      <li
        key={`${props.item.id}status-dropdown`}
        className="dropdownlistitem-container">
        <div
          onClick={() => props.changeDocumentStatus(docID, item, type)}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0"
          className="dropdownlistitem-status-container">
          <div
            style={{ backgroundColor: item.color }}
            className="status-color-container"
          />
          <Tooltip
            placement="right"
            align={{
              offset: [2, 6],
            }}
            overlayClassName="dropdownlistitem-status-tooltip"
            overlay={`${item.name}`}>
            <div>{item.name ? truncateString(item.name, 19, true) : null}</div>
          </Tooltip>
        </div>
      </li>
    );
  } else if (type === "userGroups") {
    listItemView = (
      <Fragment>
        <li
          key={`${props.item.id}tags-dropdown`}
          className="dropdownlistitem-container">
          <div
            onClick={() =>
              props.changeDocumentStatus(docID, item, type, templateId)
            }
            className="dropdownlistitem-button"
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <Tooltip
              placement="right"
              align={{
                offset: [2, 6],
              }}
              overlay={`${item.name}`}>
              <div>
                {item.name ? truncateString(item.name, 17, true) : null}
              </div>
            </Tooltip>
          </div>
        </li>
      </Fragment>
    );
  }
  return listItemView;
};

export default DropdownListItem;
